import { useCallback, useEffect, useState } from "react";
import { client } from "../lib/api";

const TOKEN_KEY = "archive_member_token";

const _headers = () => {
  const t = localStorage.getItem(TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : null;
};

/** Owner-side card hook. Returns { card, loading, error, refresh, patchSettings } */
export const useOperativeCard = () => {
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    const h = _headers();
    if (!h) {
      setCard(null); setLoading(false);
      return;
    }
    try {
      setError(null);
      const r = await client.get("/members/me/operative-card", { headers: h });
      setCard(r.data.card);
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not load Operative Card");
      setCard(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const patchSettings = useCallback(async (patch) => {
    const h = _headers();
    if (!h) return null;
    const r = await client.patch("/members/me/card-settings", patch, { headers: h });
    setCard(r.data.card);
    return r.data.card;
  }, []);

  return { card, loading, error, refresh, patchSettings };
};

/** Public-side hook for /member/:callsign */
export const usePublicOperative = (callsign) => {
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancel = false;
    if (!callsign) return;
    setLoading(true); setNotFound(false);
    client.get(`/public/operatives/${callsign}`)
      .then((r) => { if (!cancel) setCard(r.data.card); })
      .catch((e) => {
        if (cancel) return;
        if (e?.response?.status === 404) setNotFound(true);
      })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [callsign]);

  return { card, loading, notFound };
};
